import common from '../common'
const setDarkColorModel = () => {
    // 安卓
    if( !common?.isAndroid_ios() ) {
        if( window?.androidNative?.setDarkColorModel ) { 
            window.androidNative.setDarkColorModel()
        }
    }else {
        if( window?.webkit?.messageHandlers?.setDarkColorModel) {
            window?.webkit.messageHandlers.setDarkColorModel.postMessage('')
        }
    }
}
export default setDarkColorModel